import React from 'react'
import DownloadAsPDF from "../../downloads/pdf/DownloadAsPDF";
import DownloadAsCSV from "../../downloads/DownloadAsCSV";
import DownloadAsDairyComp from "../../downloads/dairycomp/DownloadAsDairyComp";
import "./samplepanel.css"

export default function SamplePanel(props){
	return (
		<div className={'sample-panel'}>
			<h4>{props.title}</h4>
			{props.children}
		</div>
	)
}